<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-09-29 17:28:47
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-09-29 17:29:45
 * @FilePath: \crm-product\found\views\mdm\views\feed_back\form\form.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import Form from '@/found/components/form';
import request from '@/found/utils/request';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
    };
  },
  async created() {
    await this.getFormRule('main_form');
    console.log(this.formConfig);
    if (this.formConfig.type === 'reply' || this.formConfig.type === 'view') {
      request
        .get('/mdm/v1/suggestion/findById', {
          id: this.formConfig.id,
        })
        .then((res) => {
          if (res.success) {
            const data = {
              ...res.result,
              imageList: res.result.imageList
                ? res.result.imageList.map((v) => v.url)
                : [],
              replyImageList: res.result.replyImageList
                ? res.result.replyImageList.map((v) => v.url)
                : [],
              replyFileList: res.result.replyFileList || [],
            };
            this.disabled(true, [
              'fileList',
              'imageList',
              'content',
              'userCode',
              'userName',
              'suggestionType',
              'suggestionName',
              'suggestionPhone'
            ]);
            this.setValue(data);
          }
        });
    }
  },
  methods: {
    setRule(v) {
      const item = v;
      if (item.field === 'replyImageList') {
        item.props = {
          ...item.props,
          limit: 10,
        };
      }
      if (item.field === 'replyFileList') {
        item.props = {
          ...item.props,
          fileMsg: '只能上传pdf,doc,docx,ppt,pptx文件',
          accept: '.pdf,.doc,.docx,.ppt,.pptx',
        };
      }
      return item;
    },
    // 提交
    submit() {
      const formData = this.getFormData();
      let replyImageList = [];
      if (formData.replyImageList && formData.replyImageList.length) {
        replyImageList = formData.replyImageList.map((v) => ({
          url: v,
        }));
      }
      request
        .post('/mdm/v1/suggestion/reply', {
          id: this.formConfig.id,
          replyContent: formData.replyContent,
          replyImageList,
          replyFileList: formData.replyFileList,
        })
        .then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
    },
  },
};
</script>
